import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

function MembershipCancel() {
  const navigate = useNavigate()

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <Box sx={{ maxWidth: 520, width: '100%', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Payment Cancelled</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You cancelled the payment. You can try again anytime.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button variant="contained" onClick={() => navigate('/payment')}>Try Again</Button>
          <Button variant="outlined" onClick={() => navigate('/membership' + window.location.search)}>View Plans</Button>
        </Box>
      </Box>
    </Box>
  )
}

export default MembershipCancel


